<template>
  <div class="content">
    <template>
      <e-breadcrumbs v-show="!!parentData.isWorking && !!parentData.isCalc" />
      <div v-if="$router.history.current.name !== 'calcIssueMain'" class="flex_box" v-show="!parentData.isWorking">
        <h1 v-show="$router.history.current.name !== 'calcIssueMain'" class="page_title">{{ $t('menu.MENU06.070') }}</h1>
        <span v-show="$router.history.current.name !== 'calcIssueMain'" class="ml_auto mt20">
          <!--a :class="auth.login ? 'button md' : 'button md disabled'" href="javascript:void(0)" @click="openPopup('DemDetTariffPop', null)">DEM/DET Tariff</a-->
          <a class="button md" href="javascript:void(0)" @click="openPopup('DemDetTariffPop', null)">DEM/DET Tariff</a><!-- Free Time Tariff -->
          <a :class="auth.login ? 'button md print ml5' : 'button md print ml5 disabled'" @click="screenToPdfDownload()" href="javascript:void(0)">
            <span class="btn_icon print"></span>{{ $t('msg.SETT060G010.002') }}
          </a>
        </span>
      </div>
    </template>
    <div class="content_box" v-show="!parentData.isWorking">
      <!-- content_box -->
      <form :key="formKey" @submit.prevent="onSearchSubmit()">
        <table class="tbl_search t2">
          <colgroup>
            <col width="*"><col width="100px">
          </colgroup>
          <tbody>
            <tr>
              <td>
                <div class="tbl_form">
                  <span class="dv wid150" style="width: 200px !important;">
                    <input type="radio" id="eiCatCd-O" name="type" v-model="params.eiCatCd" value="O" @change="changeCalcEiCatCd()">
                    <label for="eiCatCd-O" class="mr20"><span></span>{{ $t('msg.SETT060G010.003') }}</label>

                    <input type="radio" id="eiCatCd-I" name="type" v-model="params.eiCatCd" value="I" @change="changeCalcEiCatCd()">
                    <label for="eiCatCd-I"><span></span>{{ $t('msg.SETT060G010.004') }}</label>

                  </span>
                  <span class="dv wid150">
                    <select v-model="params.dtKnd">
                      <option value="BL">B/L No.</option>
                      <!-- <option value="CN">Container No.</option> -->
                    </select>
                  </span>
                  <span class="dv">
                    <input type="text" class="wid150" style="margin:0;text-transform: uppercase;" id="num" :name="blSearchFieldName(params.eiCatCd)" v-model="params.num" @blur="toUpperCase($event)">
                  </span>
                </div>
              </td>

              <td class="text_right">
                <!-- <a href="javascript:void(0)" class="button blue sh" @click="getFreeTime()">{{ $t('msg.SETT060G010.005') }}</a> -->
                <button type="submit" class="button blue sh">{{ $t('msg.SETT060G010.005') }}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div><!-- content_box // -->
    <div class="content_box" :class="{ mt10 : !parentData.isWorking}">
      <template v-for="(t, i) in tableArr">
        <calc-table :ctr-cd="ctrCd"
                    :is-first-calc-table-index="i === firstCalcTableIndex"
                    :table="t"
                    :query="freeTimeData.csbl400quiryinfo"
                    :an-check="freeTimeData.anCheck"
                    :user-type="userType"
                    :key="'calcTable-' + i"
                    :auth="auth"
                    :table-info="calcTableInfo(i)"
                    :vat-chk="vatChk"
                    :show-input-proforma-btn="showInputProformaBtn"
                    v-if="t.isShow"
                    @child="getChildData"
                    @_openPopup="_openPopup"
                    @_screenToPdfDownload="screenToPdfDownload"
        >
        </calc-table>
      </template>
    </div>
    <freetime-notice-info :ctr-cd="ctrCd" :ei-cat-cd="params.eiCatCd" :bkg-plc-cd="memberDetail.bkgPlcCd" />

    <!-- 팝업 레이어: v-if(상태)가 열림/닫힘의 유일한 근원. display:block은 .popup_dim 기본값(display:none) 상쇄용 -->
    <div v-if="customComponent" class="popup_dim" style="display: block;">
      <component
        :is="customComponent"
        @close="closePopup"
        @child="getChildData"
        @openPreviewPopup="openPreviewPopup"
        @openVaAccntPopup="openVaAccntPopup"
        :parent-info="parentInfo"
        :freight-bill-info="parentInfo"
        :user-dmd-info="userDmdInfo"
        :ei-cat-cd="eiCatCd"
        :freetime-exp-imp-rtn-sac-yn="freetimeExpImpRtnSacYn"
      />
    </div>
    <div v-if="customComponent2" class="popup_dim" style="display: block;">
      <component
        :is="customComponent2"
        @close="closePopup2"
        @child="getChildData"
        :parent-info="parentInfo2"
        :freetime-exp-imp-rtn-sac-yn="freetimeExpImpRtnSacYn"
      />
    </div>
    <div v-if="customComponent3" class="popup_dim va_popup_list" style="display: block;">
      <component
        :is="customComponent3"
        @close="closePopup3"
        :parent-info="parentInfo3"
      />
    </div>
  </div>
</template>

<script>
import CalcTable from './CalcTable'
import { rootComputed } from '@/store/helpers'
import FreeTimeApi from '@/api/rest/settle/freeTime'
import FreeTimeExtensReqPop from '@/pages/settle/popup/FreeTimeExtensReqPop'
import FreeTimePrintPop from '@/pages/settle/FreeTimePrintPop'
import PreviousIssuedInvoicePop from '@/pages/settle/PreviousIssuedInvoicePop'
import ProformaInvoicePop from '@/pages/settle/popup/ProformaInvoicePop'
import DemDetTariffPop from '@/pages/settle/popup/DemDetTariffPop'
import InputTaxInvoiceInfo from '@/pages/settle/popup/InputTaxInvoiceInfo'
import VirtualAccountInvoiceInfo from '@/pages/settle/popup/VirtualAccountInvoiceInfo'
import FreeTimePop from '@/pages/pdf/popup/FreeTimePop'
import CalcIssueInvMsgPop from '@/pages/settle/popup/CalcIssueInvMsgPop'
import CalcIssue from '@/api/rest/settle/calcIssue'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import demInvoicePop from '@/pages/settle/popup/DemInvoicePop'
import FreetimeNoticeInfo from '@/pages/settle/FreetimeNoticeInfo'
import { blSearchFieldName } from '@/plugins/searchFieldName'
import cloneDeep from 'lodash/cloneDeep'

// VAT 적용 요율 — 국가 추가/변경 시 이 표만 수정
// byPodCtr : 검색 BL의 항구 국가(podCtrCd) 기준. 화면 VAT 항목 노출(vatChk)과 연동
//            (anCheck 쿼리가 수출/수입에 따라 POL/POD를 바꿔 podCtrCd로 전달 — DECODE(#{eiCatCd},'I',POD_CTR_CD,'O',POL_CTR_CD))
// byUserCtr: 접속 사용자 국가(ctrCd) 기준 (로그인 시 계정 국가 설정 적용)
const VAT_RATES = {
  byPodCtr: { PH: 1.12 },
  byUserCtr: { KR: 1.1, PH: 1.12 }
}

export default {
  name: 'FreeTimeRequest',
  components: {
    CalcTable,
    FreeTimeExtensReqPop,
    FreeTimePrintPop,
    PreviousIssuedInvoicePop,
    ProformaInvoicePop,
    DemDetTariffPop,
    InputTaxInvoiceInfo,
    FreeTimePop,
    CalcIssueInvMsgPop,
    EBreadcrumbs,
    VirtualAccountInvoiceInfo,
    demInvoicePop,
    FreetimeNoticeInfo
  },
  props: {
    parentData: {
      type: Object,
      default: function () {
        return {
          isWorking: false,
          isCalc: false
        }
      }
    }
  },
  data: function () {
    return {
      formKey: 0,
      tableArr: [],
      params: {
        eiCatCd: 'O',
        dtKnd: 'BL',
        num: '',
        blNo: '',
        cntrNo: ''
      },
      freeTimeData: {},
      customComponent: null,
      customComponent2: null,
      customComponent3: null,
      parentInfo: {},
      parentInfo2: {},
      parentInfo3: {},
      eiCatCd: '',
      userType: 'T',
      ctrCd: 'KR',
      isReqSameCntr: 0,
      orgFreeTimeInvoiceList: [],
      srcCntr: '',
      freetimeExpImpRtnSacYn: null,
      checkData: null,
      freeDaysList: [],
      freeDaysListYn: '',
      userDmdInfo: null,
      vaInvIssNo: '',
      vaTotalAmt: '',
      showInputProformaBtn: true
    }
  },
  computed: {
    searchParams () {
       return this.$store.getters['settle/freetimeParams']
    },
    searchParamsForLogin () {
       return this.isEmpty(sessionStorage.getItem('freetimeParamsForLogin')) ? null : JSON.parse(sessionStorage.getItem('freetimeParamsForLogin'))
    },
    isLogin () {
      return !this.isEmpty(this.$store.state.auth.jwt)
    },
    selectedProfile () {
      return this.$store.getters['auth/selectedProfile']
    },
    calcEiCatCd () {
      return this.$store.getters['auth/getCalcEiCatCd']
    },
    // 검색 BL 기준 VAT 요율 (적용 대상국이 아니면 null)
    podVatRate () {
      if (this.isEmpty(this.freeTimeData) || this.isEmpty(this.freeTimeData.anCheck)) {
        return null
      }
      return VAT_RATES.byPodCtr[this.freeTimeData.anCheck.podCtrCd] || null
    },
    vatChk () {
      // 비로그인시 화면 VAT 항목 노출 구분 (false-미노출, true-노출)
      return this.podVatRate !== null
    },
    firstCalcTableIndex () {
      let idx = -1
      let isEmpty = true

      if (Array.isArray(this.tableArr)) {
        for (let i = 0; i < this.tableArr.length; i++) {
          if (this.tableArr[i].payload && this.tableArr[i].payload.rows.length !== 0) {
            isEmpty = false
            break
          }
        }
      }

      if (isEmpty === false && Array.isArray(this.tableArr)) {
        for (let i = 0; i < this.tableArr.length; i++) {
          if (this.tableArr[i].isShow) {
            idx = i
            break
          }
        }
      }
      return idx
    },
    ...rootComputed
  },
  watch: {
    searchParams: {
      deep: true,
      handler () {
        if (!this.isEmpty(this.searchParams.num)) {
          this.setParentParams()
        }
      }
    },
    calcEiCatCd () {
      if (this.parentData.isCalc) {
        this.params.eiCatCd = this.calcEiCatCd

        // 데이터 초기화
        let searchParams = {
          eiCatCd: '',
          dtKnd: '',
          num: '',
          blNo: '',
          cntrNo: ''
        }

        this.$store.commit('settle/updateFreetimeParams', searchParams)

        this.params.num = ''
        this.freeTimeData = {}

        for (let i = 0; i < this.tableArr.length; i++) {
          this.tableArr[i].payload.rows = []
          this.tableArr[i].payload.freeTimeInvoice = null
          // this.tableArr[i].eiCatCd = this.eiCatCd
        }
      }
    }
  },
  destroyed () {
    sessionStorage.removeItem('freetimeParamsForLogin')
  },
  created () {
    this.createTable()
    if (!this.isEmpty(this.searchParams.num)) {
      this.setParentParams()
    } else {
      if (this.parentData.isCalc) {
        // 프로필에서 설정한 수출/수입 값으로 세팅
        this.initEiCatCd()
      }
    }
  },
  mounted: function () {
    if (Object.keys(this.$route.query).length > 0 && this.$route.query.tab !== '1') {
      this.routerSearch(this.$route.query)
    }
    this.setSearchParamsForLogin()
    if (this.isLogin) {
      this.getUserDmd()
    }

    if (this.isLogin) {
      this.ctrCd = this.memberDetail.userCtrCd
      //this.memberDetail.bkgPlcCd
    } else {
      // 비로그인은 브라우저 언어(navigator)로만 국가 추정 (지역 없는 'ko'는 KR로) — 고객 요건 2026-07-06
      const language = navigator.language || navigator.userLanguage || ''
      if (language.startsWith('ko')) {
        this.ctrCd = 'KR'
      } else {
        this.ctrCd = (language.split('-')[1] || '').toUpperCase()
      }
    }
  },
  methods: {
    blSearchFieldName,
    onSearchSubmit () {
      this.getFreeTime()
      this.$nextTick(() => { this.formKey++ })
    },
    initEiCatCd () {
      if (this.calcEiCatCd !== '') {
        this.params.eiCatCd = this.calcEiCatCd
      } else {
        if (this.selectedProfile.eiCatCd === 'A') {
          // 프로필 값이 수출/수입이면 '수출'
          this.params.eiCatCd = 'O'
        } else {
          // 프로필에서 설정한 수출/수입 값으로 세팅
          this.params.eiCatCd = this.selectedProfile.eiCatCd
        }
      }
    },
    calcTableInfo (idx) {
      let info = {}
      let tmpArr = []

      this.tableArr.forEach((el) => {
        if (el.isShow) {
          tmpArr.push(el)
        }
      })

      tmpArr = tmpArr[tmpArr.length - 1]

      const freeDaysList = this.freeDaysList.filter(vo => { return vo.demDetCatCd === this.tableArr[idx].demDetCatCd })

      info = {
        idx: idx,
        tmpIdx: tmpArr.idx,
        freeDaysList: freeDaysList || [],
        freeDaysListYn: freeDaysList.length > 0 ? this.freeDaysListYn : 'N',
        freeday: freeDaysList.length > 0 ? freeDaysList[0].reqDds : ''
      }

      return info
    },
    async getUserDmd () {
      await CalcIssue.getUserDmd({})
        .then(async response => {
             this.userDmdInfo = response.data
        })
    },
    toUpperCase (e) {
      this.params.num = e.target.value.toUpperCase().trim()
    },
    setSearchParamsForLogin () {
      if (this.searchParamsForLogin != null) {
        this.params = {
          eiCatCd: this.searchParamsForLogin.eiCatCd,
          dtKnd: this.searchParamsForLogin.dtKnd,
          num: this.searchParamsForLogin.num
        }
        this.eiCatCd = this.searchParamsForLogin.eiCatCd
        this.getFreeTime()
        // this.freeTimeData = JSON.parse(sessionStorage.getItem('freetimeDataForLogin'))
        //  this.parseFreeTimeData(this.freeTimeData)
      }
    },
    setParentParams () {
      this.params = {
        eiCatCd: this.searchParams.eiCatCd,
        dtKnd: this.searchParams.dtKnd,
        num: this.searchParams.num,
        blNo: this.searchParams.blNo,
        cntrNo: this.searchParams.cntrNo
      }

      let searchParams = {
        eiCatCd: '',
        dtKnd: '',
        num: '',
        blNo: '',
        cntrNo: ''
      }
      this.$store.commit('settle/updateFreetimeParams', searchParams)
      this.getFreeTime()
    },
    createTable () {
      // isShow 초기값 false: 응답 전/검색 실패 시 빈 테이블 노출 방지. 응답 후 getIsShow가 카운트 기준으로 표시 결정
      this.tableArr = [
          { id: 'DEM', idx: 0, eiCatCd: 'O', demDetCatCd: '01', title: 'DEM(Demurrage)', typeText: this.$i18n.t('msg.SETT060G010.010'), isShow: false, payload: { rows: [], showCnt: 0 } },
          { id: 'DET', idx: 1, eiCatCd: 'O', demDetCatCd: '02', title: 'DET(Detention)', typeText: this.$i18n.t('msg.SETT060G010.009'), isShow: false, payload: { rows: [], showCnt: 0 } },
          { id: 'COM', idx: 2, eiCatCd: 'O', demDetCatCd: '03', title: 'DET(Combined)', typeText: this.$i18n.t('msg.SETT060G010.010') + '/' + this.$i18n.t('msg.SETT060G010.009'), isShow: false, payload: { rows: [], showCnt: 0, admExtCharge: 0 } },
          { id: 'OFC', idx: 3, eiCatCd: 'O', demDetCatCd: '14', title: 'OFC(OverFreetime Charge)', typeText: this.$i18n.t('msg.SETT060G010.010') + '/' + this.$i18n.t('msg.SETT060G010.009'), isShow: false, payload: { rows: [], showCnt: 0 } },
          { id: 'MOR', idx: 4, eiCatCd: 'O', demDetCatCd: '04', title: 'MOR(Monitoring)', typeText: this.$i18n.t('msg.SETT060G010.010'), isShow: false, payload: { rows: [], showCnt: 0 } }
      ]
    },
    getIsShow (data) {
      if (parseInt(data.dem) > 0) {
        this.tableArr[0].isShow = true
      } else {
        this.tableArr[0].isShow = false
      }
      if (parseInt(data.det) > 0) {
        this.tableArr[1].isShow = true
      } else {
        this.tableArr[1].isShow = false
      }
      if (parseInt(data.comb) > 0) {
        this.tableArr[2].isShow = true
      } else {
        this.tableArr[2].isShow = false
      }
      if (parseInt(data.ofc) > 0) {
        this.tableArr[3].isShow = true
      } else {
        this.tableArr[3].isShow = false
      }
      if (parseInt(data.mor) > 0) {
        this.tableArr[4].isShow = true
      } else {
        this.tableArr[4].isShow = false
      }

      let eta = this.freeTimeData.anCheck.eta
      let podCtrCd = this.freeTimeData.anCheck.podCtrCd

      if (this.ctrCd === 'KR' && this.params.eiCatCd === 'I' && podCtrCd === 'KR') {
        if (parseInt(eta.substr(0, 8)) >= 20210810) {
          this.tableArr[0].isShow = false
          this.tableArr[1].isShow = false
          this.tableArr[2].isShow = false
          this.tableArr[3].isShow = true
          this.tableArr[4].isShow = false
        } else {
          this.tableArr[3].isShow = false
        }
      } else {
        this.tableArr[3].isShow = false
      }
    },
    async getFreeTimeExtdtAll (arr, isCheck) {
      // 컨테이너별 독립 조회이므로 병렬 호출 (실패는 기존과 동일하게 건별 무시)
      await Promise.all(arr.map(item =>
        FreeTimeApi.getFreeTimeExtdt(this.makeQueryParams({ type: 'getFreeTimeExtdt', idx: item.idx, cntrNo: item.cntrNo, extsDt: item.extsDt, invRno: item.invRno })).then(response => {
          const row = this.tableArr[item.idx].payload.rows[item.rowIdx]
          row.extsDt = item.extsDt
          row.totAmt = response.data.rstMap.totAmt
          row.vatAmt = this.getVat(response.data.rstMap.totAmt)
          row.ovrDds = response.data.rstMap.overDds
        }).catch(e => {
          console.log(e)
        })
      ))

      if (isCheck) {
        this.$store.commit('settle/updateFreetimeVat', 'C')
      }

      this.tableArr = cloneDeep(this.tableArr)
    },
    getFreeTimeExtdt (idx, rowIdx, cntrNo, extsDt, invRno, isCheck) {
      FreeTimeApi.getFreeTimeExtdt(this.makeQueryParams({ type: 'getFreeTimeExtdt', idx: idx, cntrNo: cntrNo, extsDt: extsDt, invRno: invRno })).then(response => {
        this.tableArr[idx].payload.rows[rowIdx].extsDt = extsDt
        this.tableArr[idx].payload.rows[rowIdx].totAmt = response.data.rstMap.totAmt
        this.tableArr[idx].payload.rows[rowIdx].vatAmt = this.getVat(this.tableArr[idx].payload.rows[rowIdx].totAmt)
        this.tableArr[idx].payload.rows[rowIdx].ovrDds = response.data.rstMap.overDds
      }).catch(e => {
        console.log(e)
      })

      if (isCheck) {
        this.$store.commit('settle/updateFreetimeVat', 'C')
      }
    },
    async getFreeTime () {
      this.createTable()
      this.showInputProformaBtn = true // 검색 시작 시 초기화 (예외화주 조회 결과로 갱신)
      if (this.params.num === '') {
        if (!this.parentData.isWorking) {
            let obj = {
              onClose: () => { document.getElementById('num').focus() },
              alertType: 'simple',
              customCloseBtnClass: 'button blue lg simplert-test1',
              customCloseBtnText: this.$i18n.t('msg.SETT060G010.018'),
              useIcon: false,
              customClass: 'simple_alert',
              message: this.$i18n.t('msg.SETT060G010.017'),
              type: 'info'
            }
            this.$ekmtcCommon.alert(obj)
        }
        return false
      } else {
         if (this.params.dtKnd === 'CN') {
           this.srcCntr = this.params.num
            await FreeTimeApi.getTempBl(this.params.num).then(response => {
              this.params.num = response.data.blno
              this.params.dtKnd = 'BL'
            }).catch(e => {
              console.log(e)
            })
         } else {
           this.srcCntr = ''
         }
        await FreeTimeApi.getFreeTime(this.makeQueryParams({ type: 'getFreeTime' })).then(response => {
          // 24.08.28 Freetime 검색시, 검색하는 사람의 수출/수입 구분과 관계없이 해당 B/L 의 Freetime 검색되도록 수정
          // if (response.data.userType === 'T' || response.data.userType === this.params.eiCatCd) {
            this.userType = response.data.userType
            this.freeTimeData = response.data
            this.eiCatCd = this.params.eiCatCd
            this.parseFreeTimeData(response.data)
            sessionStorage.setItem('freetimeParamsForLogin', JSON.stringify(this.params))
            sessionStorage.setItem('freetimeDataForLogin', JSON.stringify(response.data))
          // } else {
          //   let msg = ''
          //   let ctrNm = ''
          //   if (this.ctrCd === 'KR') {
          //     ctrNm = countryCode[localStorage.getItem('service_ctrcd')].CountryNameKR
          //   } else {
          //     ctrNm = countryCode[localStorage.getItem('service_ctrcd')].CountryNameEN
          //   }
          //   if (this.params.eiCatCd === 'O') {
          //     msg = this.$t('msg.SETT060G010.056', { ctrNm: ctrNm }) //(국가)발 선적건이 아닙니다. B/L 번호를 확인해주시기 바랍니다.
          //   } else {
          //     msg = this.$t('msg.SETT060G010.057', { ctrNm: ctrNm }) //(국가)향 선적건이 아닙니다. B/L 번호를 확인해주시기 바랍니다.
          //   }
          //   this.customAlert(msg)
          // }
        }).catch(e => {
          console.log(e)
        })

        // 연장요청 내역·예외화주 조회는 로그인 사용자 대상 (비로그인은 대상 없음 + BE 세션 의존). 서로 독립이라 병렬
        if (this.isLogin) {
          await Promise.all([this.searchFreeDdsData(), this.getVaExceptionYn()])
        }
      }
    },
    // 가상계좌 예외화주 여부 (화주+방향 단위라 검색당 1회면 충분 — 기존엔 CalcTable마다 중복 호출)
    async getVaExceptionYn () {
      await FreeTimeApi.getVirtualAccountExceptionShipper({ frtKndCd: '01', eiCatCd: this.params.eiCatCd }).then(res => {
        this.showInputProformaBtn = res.data === 'Y'
      }).catch(() => {})
    },
    parseFreeTimeData (data) {
      this.getIsShow(data.isShow)
      for (let i = 0; i < this.tableArr.length; i++) {
        this.tableArr[i].payload.rows = []
        this.tableArr[i].payload.freeTimeInvoice = null
        this.tableArr[i].eiCatCd = this.eiCatCd
        this.tableArr[i].payload.admExtCharge = Number(data.admExtCharge || 0)
        if (this.tableArr[i].id === 'DEM') {
          for (let row of JSON.parse(JSON.stringify(data.demdetail4list))) {
            if (this.isEmpty(row.extsDt)) {
              row.extsDt = ''
            }
            this.tableArr[i].payload.rows.push(this.parseRow(row, 'DEM', i))
            this.tableArr[i].payload.rows[this.tableArr[i].payload.rows.length - 1].reqRno = row.wb227DemReqRno
          }
        } else if (this.tableArr[i].id === 'DET') {
          for (let row of JSON.parse(JSON.stringify(data.detdetail4list))) {
            if (this.isEmpty(row.extsDt)) {
              row.extsDt = ''
            }
            this.tableArr[i].payload.rows.push(this.parseRow(row, 'DET', i))
            this.tableArr[i].payload.rows[this.tableArr[i].payload.rows.length - 1].reqRno = row.wb227DetReqRno
          }
        } else if (this.tableArr[i].id === 'COM') {
          for (let row of JSON.parse(JSON.stringify(data.combDetailList))) {
            if (this.isEmpty(row.extsDt)) {
              row.extsDt = ''
            }
            this.tableArr[i].payload.rows.push(this.parseRow(row, 'DEM', i))
            this.tableArr[i].payload.rows[this.tableArr[i].payload.rows.length - 1].reqRno = ''
            //TODO this.tableArr[i].payload.rows[this.tableArr[i].payload.rows.length - 1].reqRno = row.wb227DemReqRno
          }
        } else if (this.tableArr[i].id === 'OFC') {
          for (let row of JSON.parse(JSON.stringify(data.demdetail4list))) {
            if (this.isEmpty(row.extsDt)) {
              row.extsDt = ''
            }
            this.tableArr[i].payload.rows.push(this.parseRow(row, 'DEM', i))
            this.tableArr[i].payload.rows[this.tableArr[i].payload.rows.length - 1].reqRno = row.wb227DemReqRno
          }
        } else if (this.tableArr[i].id === 'MOR') {
          for (let row of JSON.parse(JSON.stringify(data.monitoringDetailList))) {
            if (this.isEmpty(row.extsDt)) {
              row.extsDt = ''
            }
            this.tableArr[i].payload.rows.push(this.parseRow(row, 'MOR', i))
            this.tableArr[i].payload.rows[this.tableArr[i].payload.rows.length - 1].reqRno = ''
            //TODO this.tableArr[i].payload.rows[this.tableArr[i].payload.rows.length - 1].reqRno = row.wb227DemReqRno
          }
        }
        this.tableArr[i].payload.showCnt = this.tableArr[i].payload.rows.length
      }

        for (let i = 0; i < this.tableArr.length; i++) {
          this.orgFreeTimeInvoiceList = []

          if (data.freeTimeInvoiceList.length > 0) {
              for (let iv of data.freeTimeInvoiceList) {
                if (this.tableArr[i].demDetCatCd === iv.demDetCatCd) {
                  this.tableArr[i].payload.freeTimeInvoice = iv

                  // demDetCatCd 일치하는 인보이스 리스트 전체 담기
                  this.orgFreeTimeInvoiceList.push(iv)
                  this.tableArr[i].payload.orgFreeTimeInvoice = this.orgFreeTimeInvoiceList
                }
              }
          } else { // 프리타임 인보이스 없을때,
              this.tableArr[i].payload.orgFreeTimeInvoice = []
          }
      }

      this.freetimeExpImpRtnSacYn = data.freetimeExpImpRtnSacYn

      // this.freetimeExpImpRtnSacYn.rcvDemExpYn = 'Y'
    },
    parseRow (row, type, idx) {
      row.isChecked = true // 최초 체크상태 JamSin
      row.isShow = true
      // 퀵 메뉴에서 cntr로 진입 cntr만 체크하고 나머지는 no 체크
      if (this.srcCntr !== '') {
        row.isChecked = false
        if (row.cntrNo === this.srcCntr) {
          row.isChecked = true
        }
      }

      if (row.freeEndDt === '00000000') {
        if (type === 'DEM') {
          row.parseFreeEndDt = '-'
        } else {
          row.parseFreeEndDt = this.tableArr[idx].typeText === '未返却' ? this.tableArr[idx].typeText : this.$i18n.t('msg.SETT060G010.024') + this.tableArr[idx].typeText
        }
      } else {
        row.parseFreeEndDt = row.freeEndDt.substr(0, 4) + '.' + row.freeEndDt.substr(4, 2) + '.' + row.freeEndDt.substr(6, 2)
      }
      // 시작날짜 추가
      if (row.gateStrDt === '00000000') {
        row.parseGateStrDt = ''
      } else {
        row.parseGateStrDt = row.gateStrDt.substr(0, 4) + '.' + row.gateStrDt.substr(4, 2) + '.' + row.gateStrDt.substr(6, 2)
      }

      //port 추가
      if (this.params.eiCatCd === 'I') {
        row.parsePortNm = row.podPortNm
      } else {
        row.parsePortNm = row.polPortNm
      }

      if (row.extsDt === '00000000') {
        row.extsDt = ''
      }
      row.vatAmt = this.getVat(row.totAmt)
      row.status = this.getStatus(row, this.tableArr[idx].id)

      return row
    },
    getStatus (row, type) {
      let status = ''
      if (type === 'DEM') {
        if (row.cntrSts === 'Y') {
          status = this.$i18n.t('msg.SETT060G010.010') //반출
        } else {
          status = this.$i18n.t('msg.SETT060G010.058') //미반출
        }
      } else if (type === 'DET' || type === 'COM') {
        if (row.extsDt === '') {
          status = this.$i18n.t('msg.SETT060G010.058') //미반출
        } else if (row.cntrSts === 'Y') {
          status = this.$i18n.t('msg.SETT060G010.009') //반납
        } else {
          status = this.$i18n.t('msg.SETT060G010.059') //미반납
        }
      } else if (type === 'OFC') {
        if (row.ofcCntrSts === 'Y') {
          status = this.$i18n.t('msg.SETT060G010.009') //반납
        } else if (row.ofcCntrSts === 'N') {
          status = this.$i18n.t('msg.SETT060G010.059') //미반납
        } else if (row.ofcCntrSts === 'O') {
          status = this.$i18n.t('msg.SETT060G010.010') //반출
        } else if (row.ofcCntrSts === 'X') {
          status = this.$i18n.t('msg.SETT060G010.058') //미반출
        } else {
          status = this.$i18n.t('msg.SETT060G010.059') //미반납
        }
      } else if (type === 'MOR') {
        if (row.extsDt === '') {
          status = this.$i18n.t('msg.SETT060G010.058') //미반출
        } else if (row.cntrSts === 'Y') {
          status = this.$i18n.t('msg.SETT060G010.010') //반출
        } else {
          status = this.$i18n.t('msg.SETT060G010.058') //미반출
        }
      } else {
        status = '-'
      }
      return status
    },
    // VAT 포함 금액 계산 (순수 함수) — 요율은 상단 VAT_RATES 표 참조. BL 기준(podVatRate)이 사용자 국가 기준보다 우선
    getVat (totAmt) {
      const rate = this.podVatRate || VAT_RATES.byUserCtr[this.ctrCd]
      if (rate) {
        return parseInt(parseInt(totAmt) * rate)
      }
      return parseInt(totAmt)
    },
    makeQueryParams (data) {
      let params = '?'
      switch (data.type) {
        case 'getFreeTime':
          if (this.params.dtKnd === 'BL') {
            params += 'blNo=' + this.params.num
          } else if (this.params.dtKnd === 'CN') {
            params += 'cntrNo=' + this.params.num
          }
          params += '&dtKnd=' + this.params.dtKnd
          params += '&eiCatCd=' + this.params.eiCatCd
          // 이 화면은 요청내역·Storage 목록을 쓰지 않으므로 BE 조회 최적화 요청 (BB/SB2)
          params += '&scope=freetime'
        break
        case 'getFreeTimeExtdt':
          params += 'blNo=' + this.freeTimeData.blno
          params += '&cntrNo=' + data.cntrNo
          // params += '&demDetCatCd=0' + (parseInt(this.tableArr[data.idx].idx) + 1) ????? this.tableArr[].demDetCatCd 이걸 만들어 놓고 이렇게 하는 이유는?
          params += '&demDetCatCd=' + this.tableArr[data.idx].demDetCatCd
          params += '&eiCatCd=' + this.freeTimeData.asEiCatCd
          params += '&extsDt=' + data.extsDt
          params += '&invRno=' + data.invRno
        break
        case 'fnDoKLNetSend':
          params += 'blNo=' + data.blNo
          params += '&cntrNo=' + data.cntrNo
          params += '&flag=' + data.flag
        break
      }

      return params
    },
    fnDoKLNetSend (idx) {
      let detNotCnt = 0
      let blCheckCnt = 0
      let blNo = (this.isEmpty(this.freeTimeData.blno) ? '' : this.freeTimeData.blno.replace('KMTC', ''))
      let cntrNo = ''
      let parm = ''
      let rtnStr = ''
      let now = new Date()
      let year = now.getFullYear()
      let mon = (now.getMonth() + 1) > 9 ? '' + (now.getMonth() + 1) : '0' + (now.getMonth() + 1)
      let day = now.getDate() > 9 ? '' + now.getDate() : '0' + now.getDate()
      let to_day = year + mon + day
      let det_break = '' //01. 미반출, 02. 반납기한 지남.
      let dem_break = '' //01. 미반출, 02. 반납기한 지남.

      let flag = (this.tableArr[idx].id === 'DEM' || this.tableArr[idx].id === 'DET') ? this.tableArr[idx].id : 'DEM'
      if (flag === 'DET') {
        for (let row of this.tableArr[idx].payload.rows) {
          if (row.isChecked) {
            blCheckCnt++
            if (row.freeEndDt === '00000000') {
              det_break = '01'
              break
            }
            if (row.freeEndDt !== '00000000' && parseInt(row.freeEndDt) < parseInt(to_day)) {
              det_break = '02'
              break
            }
          }
        }
        if (det_break === '01') {
          this.customAlert(this.$i18n.t('msg.SETT060G010.025'))
          return false
        } else if (det_break === '02') {
          this.customAlert(this.$i18n.t('msg.SETT060G010.026'))
          return false
        }
        if (blCheckCnt === 0) {
          this.customAlert(this.$i18n.t('msg.SETT060G010.027'))
          return false
        }
      } else {
        for (let row of this.tableArr[idx].payload.rows) {
          if (row.isChecked) {
            blCheckCnt++
            if (row.freeEndDt === '00000000') {
              dem_break = '01'
              break
            }
            if (row.freeEndDt !== '00000000' && parseInt(row.freeEndDt) < parseInt(to_day)) {
              dem_break = '02'
              break
            }
          }
        }
        if (dem_break === '01') {
          this.customAlert(this.$i18n.t('msg.SETT060G010.025'))
          return false
        } else if (dem_break === '02') {
          this.customAlert(this.$i18n.t('msg.SETT060G010.028'))
          return false
        }
        if (blCheckCnt === 0) {
          this.customAlert(this.$i18n.t('msg.SETT060G010.027'))
          return false
        }
      }
      FreeTimeApi.sendKLNetDo(this.makeQueryParams({ type: 'fnDoKLNetSend', blNo: blNo, cntrNo: cntrNo, flag: flag })).then(response => {
          switch (response.data) {
            case '01':
              this.customAlert(this.$t('msg.SETT060G010.048')) // 전송되었습니다.
              break
            case '02':
              this.customAlert(this.$t('msg.SETT060G010.029')) // D/O가 발행되지 않았습니다.
              break
            case '03':
              this.customAlert(this.$t('msg.SETT060G010.030')) // Demurrage가 초과되었습니다.
              break
            case '04':
              this.customAlert(this.$t('msg.SETT060G010.031')) // Detention이 초과되었습니다.
              break
            case '05':
              this.customAlert(this.$t('msg.SETT060G010.049')) // 전송에 실패 하였습니다.
              break
            default:
              this.customAlert(this.$t('msg.SETT060G010.049')) // 전송에 실패 하였습니다.
              break
          }
        }).catch(e => {
          console.log(e)
          this.customAlert(this.$i18n.t('msg.SETT060G010.032'))
        })
    },
    async getChildData (data) {
      let showCnt = 0
      switch (data.type) {
        case 'onlyCost':
          for (let i = 0; i < this.tableArr[data.payload.idx].payload.rows.length; i++) {
            if (data.payload.isOnlyCost) {
              if (parseInt(this.tableArr[data.payload.idx].payload.rows[i].totAmt) === 0) {
                this.tableArr[data.payload.idx].payload.rows[i].isShow = false
              } else {
                showCnt++
                this.tableArr[data.payload.idx].payload.rows[i].isShow = true
              }
            } else {
              showCnt++
              this.tableArr[data.payload.idx].payload.rows[i].isShow = true
            }
          }
          this.tableArr[data.payload.idx].payload.showCnt = showCnt
          break
        case 'changeExts':
          this.getFreeTimeExtdt(data.payload.idx, data.payload.rowIdx, data.payload.cntrNo, data.payload.extsDt, data.payload.invRno, data.isCheck)
          break
        case 'AllChangeExts':
          this.getFreeTimeExtdtAll(data.payload, data.isCheck)
          break
        case 'openPopup':
          if (data.payload.compNm === 'FreeTimePop') {
            this.openPopup(data.payload.compNm, data.payload.demDetAppNo)
          } else {
            if (data.payload.compNm === 'InputTaxInvoiceInfo' || data.payload.compNm === 'FreeTimeExtensReqPop' || data.payload.compNm === 'VirtualAccountInvoiceInfo') {
              this.isReqSameCntr = 0

              // 인보이스 paid / no paid (입금여부) 여부 체크
              let invoiceCntrList = []
              let gridCheckedRows = []

              // Invoice가 없는 항목일 경우 스크립트 오류 발생하여 수정
              invoiceCntrList = this.isEmpty(this.tableArr[data.payload.idx].payload.orgFreeTimeInvoice) ? [] : this.tableArr[data.payload.idx].payload.orgFreeTimeInvoice

              if (invoiceCntrList.length > 0) {
                // INVOICE 발급된 컨테이너 비교 작업
                this.tableArr[data.payload.idx].payload.rows.forEach(vo => {
                  if (vo.isChecked) {
                    gridCheckedRows.push(vo)
                  }
                })

                invoiceCntrList.forEach(v => {
                  // 체크된 값
                  gridCheckedRows.forEach(v2 => {
                    if (v.cntrNo === v2.cntrNo) { // 세금계산어 팝업 오픈시 Request, pending 체크
                      if (v.apvStsCd === '02' || v.apvStsCd === '07') {
                        this.isReqSameCntr += 1
                      }
                    }
                  })
                })
              }
            }

            this.openPopup(data.payload.compNm, data.payload.idx)
          }
          break
        case 'fnDoKLNetSend':
          this.fnDoKLNetSend(data.payload.idx)
          break
        case 'returnDateCancel':
          this.returnDateCancel(data.payload.idx)
          break
        case 'returnDateSubmit':
          this.returnDateSubmit(data.payload.idx)
          break
      }
    },
    async returnDateCancel (idx) {
      await this.$Simplert.close()
      let checkLen = 0
      let ar216iTotAmtYn = 'N'
      for (let row of this.tableArr[idx].payload.rows) {
        if (row.isChecked) {
          checkLen++
          if (!this.isEmpty(row.ar216iTotAmt)) {
            ar216iTotAmtYn = 'Y'
          }
        }
      }

      if (checkLen === 0) {
        this.customAlert(this.$t('msg.SETT060G010.046')) // 컨테이너를 선택해주세요.
        return
      }

      if (ar216iTotAmtYn === 'N') {
        this.customAlert('Cannot be reset.')
        return
      }

      FreeTimeApi.deleteDecInv(this.freeTimeData.csbl400quiryinfo.blNo).then(response => {
        if (response.data === '1') {
          this.customAlert('Completed to reset.')
          this.getFreeTime()
          //this.customAlert('success.')
        } else if (response.data === '2') {
          this.customAlert('Payment request is received and in process.')
          //this.customAlert('That\'s impossible.')
        } else {
          this.customAlert('Reset failed. Please get in contact with administrator.')
          //this.customAlert('Error.')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    async returnDateSubmit (idx) {
      await this.$Simplert.close()
      let arr = []
      let totAmt = 0
      for (let row of this.tableArr[idx].payload.rows) {
        if (row.isChecked) {
          arr.push(row)
          totAmt += row.totAmt * 1
        }
      }
      if (arr.length === 0) {
        this.customAlert(this.$t('msg.SETT060G010.046')) // 컨테이너를 선택해주세요.
        return
      }
      if (totAmt === 0) {
        this.customAlert('Please Check Amount.')
        return
      }
      //DOE
      const extsDtList = [...new Set(
        arr.map(row => row.extsDt).filter(v => !!v)
      )]

      let needChargeYn = 'N'
      let chargeExtDt = ''
      let chargeAmount = 0

      try {
        const checkRes = await FreeTimeApi.checkDoeCharge({
          blNo: this.freeTimeData.csbl400quiryinfo.blNo,
          uno: this.auth.uno,
          extsDtList
        })

        needChargeYn = checkRes.data.needChargeYn || 'N'
        chargeExtDt = checkRes.data.chargeExtDt || ''
        chargeAmount = Number(checkRes.data.amount || 200000).toLocaleString()
      } catch (e) {
        console.log(e)
        this.customAlert('DOE charge check failed. Please get in contact with administrator.')
        return
      }

      if (needChargeYn === 'Y') {
        const okCharge = await this.$ekmtcCommon.asyncAlertMessage({
          message: `An IDR ${chargeAmount} D/O extension charge will apply.` + '\n' + 'After submit the return date, please upload payment evidence in D/O request. <br/> Would you like to register?',
          useConfirmBtn: true
        })

        if (!okCharge) return
      } else {
         const okDoIssue = await this.$ekmtcCommon.asyncAlertMessage({
          message: 'After submit the return date, please upload payment evidence in D/O request. <br/> Would you like to register?',
          useConfirmBtn: true
        })

        if (!okDoIssue) return
      }
      try {
        const saveRes = await FreeTimeApi.submitReturnDateWithDoeCharge({
          blNo: this.freeTimeData.csbl400quiryinfo.blNo,
          uno: this.auth.uno,
          rows: arr,
          approveDoeChargeYn: needChargeYn,
          chargeExtDt
        })

        if (saveRes.data.resultCd === '1') {
          this.customAlert(saveRes.data.resultMsg || 'Completed to save.')
          this.getFreeTime()
        } else if (saveRes.data.resultCd === '2') {
          this.customAlert(saveRes.data.resultMsg || 'Payment request is received and in process.')
        } else {
          this.customAlert(saveRes.data.resultMsg || 'Save failed. Please get in contact with administrator.')
        }
      } catch (e) {
        console.log(e)
        this.customAlert('Save failed. Please get in contact with administrator.')
      }
    },
    async getInputData (idx, compNm, blNo) {
      // 입금/계산서 정보입력 팝업 오픈시. 이전 저장된 데이터를 불러오지 않고 팝업을 오픈한다.
      this.parentInfo = this.parseInputTaxInvoiceInfo(idx, null)
      this.customComponent = compNm
    },
    replaceKmtcBlNo (blNo) { // BL번호에서 KMTC 제거
      if (blNo) {
        return blNo.replace('KMTC', '')
      } else {
        return blNo
      }
    },
    async openPopup (compNm, idx) {
      let target = 'main'
      switch (compNm) {
        case 'FreeTimeExtensReqPop':
          this.parentInfo = this.makeExtensReqPopInfo(idx)
          break
        case 'FreeTimePrintPop':
          this.parentInfo = this.makeFreeTimePrintPopInfo()
          break
        case 'PreviousIssuedInvoicePop':
          this.parentInfo = this.makePreviousIssuedInvoicePopInfo(idx)
          break
        case 'CalcIssueInvMsgPop':
          this.parentInfo = this.makeCalcIssueInvMsgPopInfo(idx)
          break
        case 'FreeTimePop':
          target = 'child'
          this.parentInfo2 = this.makeFreeTimePopInfo(idx)
          break
        case 'ProformaInvoicePop': {
          const info = await this.makeProformaInvoicePopInfo(idx)
          if (!info) {
            return
          }
          this.parentInfo = info
          break
        }
        case 'InputTaxInvoiceInfo':
          await this.openInputTaxInvoicePopup(idx, compNm)
          return
        case 'VirtualAccountInvoiceInfo':
          await this.openVirtualAccountPopup(idx, compNm)
          return
      }
      this.openLayerPopup(compNm, target)
    },
    openLayerPopup (compNm, target) {
      if (target === 'child') {
        this.customComponent2 = compNm
      } else {
        this.customComponent = compNm
      }
    },
    makeExtensReqPopInfo (idx) {
      return {
        blNo: this.replaceKmtcBlNo(this.freeTimeData.csbl400quiryinfo.blNo),
        eiCatCd: this.freeTimeData.csbl400quiryinfo.eiCatCd,
        sr: '',
        demDetCatCd: this.tableArr[idx].demDetCatCd,
        freeTimeInvoice: this.tableArr[idx].freeTimeInvoice,
        tableArr: this.tableArr
      }
    },
    makeFreeTimePrintPopInfo () {
      return {
        blNo: this.freeTimeData.csbl400quiryinfo.blNo,
        demDetCatCd: '', // ??
        eiCatCd: this.freeTimeData.csbl400quiryinfo.eiCatCd,
        ctrCd: this.memberDetail.userCtrCd
      }
    },
    makePreviousIssuedInvoicePopInfo (idx) {
      return {
        blNo: this.freeTimeData.csbl400quiryinfo.blNo,
        demDetCatCd: this.tableArr[idx].demDetCatCd,
        eiCatCd: this.freeTimeData.csbl400quiryinfo.eiCatCd,
        lang: this.auth.serviceLang,
        usrNm: this.selectedProfile.picEnm,
        ctrCd: this.memberDetail.userCtrCd,
        idx: idx
      }
    },
    makeCalcIssueInvMsgPopInfo (idx) {
      return {
        freeTimeInvoice: this.tableArr[idx].payload.freeTimeInvoice,
        blNo: this.freeTimeData.csbl400quiryinfo.blNo
      }
    },
    makeFreeTimePopInfo (demDetAppNo) {
      return {
        items: [
          {
            blNo: this.replaceKmtcBlNo(this.freeTimeData.csbl400quiryinfo.blNo),
            pDemDetAppNo: demDetAppNo
          }
        ]
      }
    },
    // 입금/계산서·가상계좌 팝업 공통 사전 체크 (컨테이너 선택 여부 / 기 입금요청 건)
    validateCheckedCntrCommon (idx) {
      if (this.getCheckCnt(idx) === 0) {
        this.customAlert(this.$t('msg.SETT060G010.046')) // 컨테이너를 선택해주세요.
        return false
      }
      if (this.isReqSameCntr > 0) {
        // 입금계산서 요청한 건중 requset, pending 상태인 건
        setTimeout(() => {
          this.customAlert('이미 입금 요청한 컨테이너가 존재합니다.')
        }, 100)
        return false
      }
      return true
    },
    async openInputTaxInvoicePopup (idx, compNm) {
      if (!this.validateCheckedCntrCommon(idx)) {
        return
      }

      let isZero = false
      let cntrReturn = false

      for (let row of this.tableArr[idx].payload.rows) {
        // 반납완료된 컨테이너 포함이면 팝업
        if (row.isChecked && row.cntrSts === 'Y' && this.freeTimeData.anCheck.podCtrCd === 'KR' && this.tableArr[idx].id === 'OFC') {
          cntrReturn = true
        }

        if (row.isChecked && row.vatAmt === 0) {
          isZero = true
        }
      }
      const isFeeChg = await this.checkFreeDayChanged(this.tableArr[idx].payload.rows, this.tableArr[idx].demDetCatCd)

      if (cntrReturn) {
        if (!await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.SETT060G010.067'), useConfirmBtn: true })) {
          return
        }
      }

      if (isZero) {
        setTimeout(() => {
          this.customAlert(this.$t('msg.SETT060G010.047')) // 금액이 0인 컨테이너가 포함되어 있습니다.
        }, 100)
      } else if (isFeeChg) {
        setTimeout(() => {
          this.$ekmtcCommon.alertCallback(this.$t('경과일이 상이합니다. 변경된 경과일을 확인 후 신청하시기 바랍니다.'), () => {
            this.getFreeTime()
          })
        }, 100)
      } else {
        this.getInputData(idx, compNm, this.freeTimeData.csbl400quiryinfo.blNo)
      }
    },
    // Proforma Invoice 팝업 데이터 구성. 사전 체크 실패 시 알림 후 null 반환
    async makeProformaInvoicePopInfo (idx) {
      let calExts = ''
      let comma = ''
      let cnt = 0
      let cntrReturn = false
      let case1 = false
      for (let i = 0; i < this.tableArr[idx].payload.rows.length; i++) {
        if (this.tableArr[idx].payload.rows[i].isChecked) {
          cnt++
          const cntrNo = this.tableArr[idx].payload.rows[i].cntrNo
          const extsDt = this.tableArr[idx].payload.rows[i].extsDt
          const ovrDds = this.tableArr[idx].payload.rows[i].ovrDds
          const totAmt = this.tableArr[idx].payload.rows[i].totAmt
          const vatAmt = this.tableArr[idx].payload.rows[i].vatAmt
          const imsiDcAmt = parseInt((this.tableArr[idx].payload.rows[i].imsiDcAmt) ? this.tableArr[idx].payload.rows[i].imsiDcAmt : 0)
          calExts += comma + cntrNo + '_' + extsDt + '_' + ovrDds + '_' + totAmt + '_' + vatAmt + '_' + imsiDcAmt
          comma = ','

          if (this.tableArr[idx].payload.rows[i].vaOdckYn === 'N' && this.tableArr[idx].payload.rows[i].shprVanYn === 'Y') {
            case1 = true
          }

          // 반납완료된 컨테이너 포함이면 팝업
          if (this.tableArr[idx].payload.rows[i].cntrSts === 'Y' && this.freeTimeData.anCheck.podCtrCd === 'KR' && this.tableArr[idx].id === 'OFC') {
            cntrReturn = true
          }
        }
      }

      if (case1) {
        this.customAlert('화주 VAN으로 정산할 금액이 없습니다.\n[DEM/DET/FREETIME]탭에서 [Freetime 연장 요청]\n기능을 이용해 주시기 바랍니다.')
        return null
      }

      if (cntrReturn) {
        if (!await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.SETT060G010.067'), useConfirmBtn: true })) {
          return null
        }
      }

      if (cnt === 0) {
        this.customAlert(this.$t('msg.SETT060G010.046')) // 컨테이너를 선택해주세요.
        return null
      }
      return {
        blNo: this.freeTimeData.csbl400quiryinfo.blNo,
        demDetCatCd: this.tableArr[idx].demDetCatCd,
        eiCatCd: this.freeTimeData.csbl400quiryinfo.eiCatCd,
        calExts: calExts,
        invIssNo: '',
        idx: idx
      }
    },
    async openVirtualAccountPopup (idx, compNm) {
      // 가상계좌 신청내역에서 재진입한 경우 바로 입력 팝업 오픈
      if (!this.$ekmtcCommon.isEmpty(this.vaInvIssNo)) {
        this.getInputData(idx, compNm, this.freeTimeData.csbl400quiryinfo.blNo)
        return
      }

      if (!this.validateCheckedCntrCommon(idx)) {
        return
      }

      let isZero = false
      let cntrReturn = false
      let shprVanYn = false
      let accTimeYn = false
      let totalAmt = 0
      let imsiDcAmt = 0
      let dcAmount = 0
      let case1 = false //KR향 수입 비온독 SHIPPER’S VAN은 가상계좌 사용 불가 유지

      for (let row of this.tableArr[idx].payload.rows) {
        imsiDcAmt += parseInt((row.imsiDcAmt) ? row.imsiDcAmt : 0)
        if (row.isChecked) {
          dcAmount += parseInt(row.vatAmt) * parseInt(row.dcRt) / 100
        }
        // 반납완료된 컨테이너 포함이면 팝업
        if (row.isChecked && row.cntrSts === 'Y' && this.freeTimeData.anCheck.podCtrCd === 'KR' && this.tableArr[idx].id === 'OFC') {
          cntrReturn = true
        }

        if (row.isChecked && row.shprVanYn === 'Y') {
          shprVanYn = true
        }

        if (row.isChecked && row.vaOdckYn === 'N' && shprVanYn) {
          case1 = true
        }

        if (row.isChecked && row.vatAmt === 0) {
          isZero = true
        }

        if (row.isChecked && row.vatAmt !== 0) {
          totalAmt = totalAmt + row.vatAmt
        }
      }
      const isFeeChg = await this.checkFreeDayChanged(this.tableArr[idx].payload.rows, this.tableArr[idx].demDetCatCd)

      if (cntrReturn) {
        this.customAlert('반납 완료된 컨테이너는 가상 계좌 사용이 불가능합니다.')
        return
      }

      if (case1) {
        this.customAlert('화주 VAN으로 정산할 금액이 없습니다.\n[DEM/DET/FREETIME]탭에서 [Freetime 연장 요청]\n기능을 이용해 주시기 바랍니다.')
        return
      }

      //Freetime 연장 여부 체크
      const freeTimeReqYn = await this.checkHasCm134IFreetime(this.freeTimeData.csbl400quiryinfo.blNo)
      if (freeTimeReqYn) {
        let freeCanYn = false
        if (await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.ONEX070G050.016'), useConfirmBtn: true })) {
          freeCanYn = await this.cancelReq()
        }
        if (freeCanYn) {
          await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.ONEX070G050.017') })
        } else {
          return
        }
      }
      //가상계좌 사용 시간 체크
      accTimeYn = await this.acctTimeYn()
      if (accTimeYn !== 'Y') {
        this.customAlert('지금은 가상계좌 사용이 불가합니다.' + '\n' + '(사용 가능 시간 : 평일 09:00 ~ 17:50까지)')
        return
      }
      if (isZero) {
        setTimeout(() => {
          this.customAlert(this.$t('msg.SETT060G010.047')) // 금액이 0인 컨테이너가 포함되어 있습니다.
        }, 100)
        return
      }
      if (isFeeChg) {
        setTimeout(() => {
          this.$ekmtcCommon.alertCallback(this.$t('경과일이 상이합니다. 변경된 경과일을 확인 후 신청하시기 바랍니다.'), () => {
            this.getFreeTime()
          })
        }, 100)
        return
      }

      totalAmt = this.$ekmtcCommon.changeNumberFormat((totalAmt - dcAmount - (imsiDcAmt > 0 ? imsiDcAmt + (imsiDcAmt * 0.1) : 0)), { isComma: true })
      let msg = ''
      msg += totalAmt + '원 결제를 진행 하시겠습니까?<br>'
      msg += '가상계좌 입금 이후 단순 변심으로 인한 취소 시 환불 불가합니다.'
      msg += '<div style="height: 20px">'
      msg += '<input id="virtualAccountAgreeYn" type= "checkbox" / ><label for="virtualAccountAgreeYn">동의</label>'
      msg += '</div>'

      // 동의 체크 후 확인 시에만 isOpen=true (미체크 확인은 안내 후 대기, 닫기는 취소)
      let isOpen = false
      await this.$ekmtcCommon.asyncAlertMessage({
        message: msg,
        useConfirmBtn: true,
        onConfirmSelf: (resolve, $Simplert) => {
          const virtualAccountAgreeYn = document.querySelector('#virtualAccountAgreeYn')

          if (!virtualAccountAgreeYn.checked) {
            this.$ekmtcCommon.alertDefault('동의 되지 않았습니다.')
            isOpen = false
          } else {
            isOpen = true
            resolve(true)
            $Simplert.close()
          }
        },
        onCloseSelf: (resolve, $Simplert) => {
          resolve(false)
          $Simplert.close()
          isOpen = false
        }
      })

      if (isOpen) this.getInputData(idx, compNm, this.freeTimeData.csbl400quiryinfo.blNo)
    },
    getCheckCnt (idx) {
      let cnt = 0

      for (let row of this.tableArr[idx].payload.rows) {
        if (row.isChecked) {
          cnt++
        }
      }

      return cnt
    },
    closePopup (obj) {
      if (this.$store.state.settle.isRefreshFreetimeReq) {
        this.getFreeTime()
        this.$store.commit('settle/updateIsRefreshFreetimeReq', false)
      }
      this.customComponent = null
    },
    closePopup2 (obj) {
      this.customComponent2 = null
    },
    closePopup3 (obj) {
      this.customComponent3 = null
    },
    openPreviewPopup (obj) {
      this.customComponent = null

      this.parentInfo3 = {
        invoice: {
          invIssNo: obj.invIssNo,
          demDetCatCd: obj.demDetCatCd
        },
        blNo: this.freeTimeData.csbl400quiryinfo.blNo,
        demDetCatCd: obj.demDetCatCd,
        eiCatCd: this.freeTimeData.csbl400quiryinfo.eiCatCd,
        lang: this.auth.serviceLang,
        usrNm: this.selectedProfile.picEnm,
        ctrCd: this.memberDetail.userCtrCd
      }
      this.customComponent3 = 'demInvoicePop'
    },
    screenToPdfDownload () {
      let datepickerList = document.querySelectorAll('.datepicker')
      datepickerList.forEach((element, index, array) => {
        document.getElementById(element.id).style.height = '32px'
      })
      this.$ekmtcCommon.screenToPdf({ cssSelector: 'body > div .content', fileName: 'Freetime_Req.pdf', download: 'Y' })
      datepickerList.forEach((element, index, array) => {
        document.getElementById(element.id).style.height = '24px'
      })
    },
    parseInputTaxInvoiceInfo (idx, data) {
      let krw = 0
      let cntrList = []
      let inputDefaultData = {}
      if (!this.isEmpty(data)) {
        inputDefaultData = data[data.length - 1]
      }
      for (let row of this.tableArr[idx].payload.rows) {
        let r = JSON.parse(JSON.stringify(row))

        // 컨테이너 전체 입금계산서 팝업으로 넘겨줌.
        if (row.isChecked) {
          r.cfmYn = 'Y'

          // 컨테이너 중 체크된 row
          r.cntrQty = 1

          let imsiDcAmt = parseInt((row.imsiDcAmt) ? row.imsiDcAmt : 0)
          krw += parseInt(row.vatAmt) - (parseInt(row.vatAmt) * parseInt(row.dcRt) / 100) - (imsiDcAmt + (imsiDcAmt * 0.1))
          r.dcAmt = parseInt(row.totAmt) * parseInt(row.dcRt) / 100
          r.totAmt = parseInt(row.totAmt) - (parseInt(row.totAmt) * parseInt(row.dcRt) / 100)
        } else {
          r.cntrQty = 0
        }

        cntrList.push(r)
      }

      const eiCatCd = this.freeTimeData.csbl400quiryinfo.eiCatCd

      let info = {
        dpId: 'SETT060G010',
        dpType: 'F',
        inputDefaultData: inputDefaultData,
        btnType: eiCatCd === 'O' ? 'DEMDET' : 'OFC',
        totalAmt: krw,
        demDetCatText: this.tableArr[idx].id,
        payload: this.tableArr[idx].payload,
        isShow: {
          info: false,
          method: true,
          tax: true
        },
        blList: [{
          blNo: this.replaceKmtcBlNo(this.freeTimeData.csbl400quiryinfo.blNo),
          krw: krw,
          usd: 0,
          exRate: 1136,
          currency: 'KRW',
          obrdDt: '', //TODO
          demDetCatCd: this.tableArr[idx].demDetCatCd,
          eiCatCd: this.freeTimeData.csbl400quiryinfo.eiCatCd,
          cntrList: cntrList
        }],
        bookingInfo: null,
        vaInvIssNo: this.vaInvIssNo
      }

      if (!this.$ekmtcCommon.isEmpty(this.vaInvIssNo)) {
        this.vaInvIssNo = ''
        info.totalAmt = this.vaTotalAmt
        this.vaTotalAmt = ''
      }
      return info
    },
    isEmpty (value) {
      if (value === '' || value === null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
          return true
      } else {
          return false
      }
    },
    customAlert (msg) {
      let obj = {
          alertType: 'simple',
          customCloseBtnClass: 'button blue lg simplert-test1',
          customCloseBtnText: this.$i18n.t('msg.SETT060G010.018'),
          useIcon: false,
          customClass: 'simple_alert',
          message: msg,
          type: 'info'
        }
        this.$ekmtcCommon.alert(obj)
    },
    routerSearch (data) {
      this.params = { ...this.params, ...data }
      this.getFreeTime()
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ query: {} })
      }
    },
    changeCalcEiCatCd () {
      if (this.parentData.isCalc) {
        this.$store.commit('auth/updateCalcEiCatCd', this.params.eiCatCd)
      }
    },
    _openPopup () {
      this.openPopup('DemDetTariffPop', null)
    },
    _screenToPdfDownload () {
      this.screenToPdfDownload()
    },
    async acctTimeYn () {
      let result = ''
      //가상계좌 사용시간
      await FreeTimeApi.getAcctTimeYn().then(async response => {
        result = response.data.acctTimeYn
      }).catch(() => {
        result = 'N'
      })
      return result
    },
    // 전체 row의 경과일 변경 여부를 병렬로 확인 (하나라도 'Y'면 true)
    async checkFreeDayChanged (rows, demDetCatCd) {
      const results = await Promise.all(rows.map(row => this.freeDaySync(row, demDetCatCd)))
      return results.includes('Y')
    },
    async freeDaySync (row, demDetCatCd) {
       const params = {
        blNo: row.blNo,
        cntrNo: row.cntrNo,
        demSeq: row.demSeq,
        freeDds: row.freeDds,
        freeEndDt: row.freeEndDt,
        invRno: row.invRno,
        demDetCatCd: demDetCatCd
      }
      let result = ''
      await FreeTimeApi.getFreeDaySync(params).then(async response => {
        result = response.data.freeDayRtn
      }).catch(() => {
        result = ''
      })
      return result
    },
    openVaAccntPopup (args) {
      this.vaInvIssNo = args.invIssNo
      this.vaTotalAmt = args.locAmt
      this.openPopup(args.compNm, args.idx)
    },
    async cancelReq () {
      let result = false
      await FreeTimeApi.cancelSa206i(this.checkData.sa206i).then(async response => {
        result = true
      }).catch(e => {
        result = false
      })
      return result
    },
    async checkHasCm134IFreetime (blNo) {
      let result = false
      await CalcIssue.checkHasCm134IFreetime({
        blNo: blNo,
        reqBizCatCd: ''
      }).then(async response => {
        this.checkData = response.data
        if (this.isEmpty(response.data)) {
          result = false
        } else if (!this.isEmpty(response.data.sa206i)) {
          result = true
        }
      }).catch(e => {
        result = false
       })
      return result
    },
    async searchFreeDdsData () {
      // 조회 실패 등으로 검색 결과가 없으면 skip (csbl400quiryinfo 접근 오류 방지)
      if (this.isEmpty(this.freeTimeData) || this.isEmpty(this.freeTimeData.csbl400quiryinfo)) {
        return
      }

      let param = {}
      param.blNo = this.freeTimeData.csbl400quiryinfo.blNo
      param.demDetCatCd = ''
      param.eiCatCd = this.freeTimeData.csbl400quiryinfo.eiCatCd

      await FreeTimeApi.getFreeTimeList(param).then(response => {
        let data = response.data

        let freeDaysList = data.rstList

        if (data.rstList.length > 0) {
          this.freeDaysListYn = 'Y'

          freeDaysList.sort((f, s) => {
            return Number(f.demDetAppNo) - Number(s.demDetAppNo)
          })

          this.freeDaysList = freeDaysList.filter(vo => { return vo.apvStsCd === '03' })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
/* 팝업 딤: 딤 위 휠 스크롤이 배경 페이지로 전파되지 않도록 차단 (기존 body overflow 잠금의 CSS 대체) */
.popup_dim {
  overflow-y: auto;
  overscroll-behavior: contain;
}
</style>
